import Vue from 'vue'
import App from './App.vue'
import router from './router'

// Must be set before the scripts are included
window.dFlipLocation = window.location.origin + '/lib/dflip/'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
